module.exports = __webpack_public_path__ + "static/media/Website.a2b80c42.png";